import MergeProfiles from "./MergeProfiles";
export default MergeProfiles;
